module.exports = __webpack_public_path__ + "img/哈蟆油.5213fe0f.jpg";